import BulkKeywordReplacementDrawer from './BulkKeywordReplacementDrawer';

export default BulkKeywordReplacementDrawer;
